import React from "react";

const ButtonLoader = (props) => {
  return (
    // type="button" + disabled so clicking the loader inside a <form> can never trigger a second submit
    <button type="button" disabled className={`buttonload group relative btn btn-red text-xl border text-white focus:outline-none cursor-not-allowed ${props.className ? props.className : ""}`}>
      <span className="absolute left-[15px] flex items-center ">
        <i className="fa fa-spinner fa-spin text-white text-[17px]"></i>
      </span>
      <span className="ml-8">
      Loading
      </span>
    </button>
  );
};

export default ButtonLoader;
